import cx from 'classnames';
import { useContext } from 'react';

import Container from '@/next-components/container';
import Blocks from '@/next-components/blocks';
import useHandleInternalLinks from '@/hooks/useHandleInternalLinks';
import { ThemeContext } from '@/contexts/theme-context';
import omit from '@/utils/omit';
import { Image } from '@/components/molecules/Image/render';
import { SectionTwoColumnsCol } from '@/components/organisms/SectionTwoColumns/blocks/Column/render.tsx';
import { HeaderA } from '@/components/organisms/HeaderA/render';
import blockHeaderA from '@/components/organisms/HeaderA/block.json';
import { getStyles as getPageStyles } from '@/components/templates/SinglePage/styles.css';
import { SinglePageThemeControls } from '@/components/templates/SinglePage/theming';
import { formatImage } from '@/lib/formaters/formatImage';

import { getStyles, getHeaderStyles } from './styles.css';

export default function Artist({ node, preview }) {
	const blocks = node?.blocksJSON ? JSON.parse(node.blocksJSON) : [];

	const handleInternalLinks = useHandleInternalLinks();

	// Merge: defaults + theme (variant base + variant active)
	const { rawTheme, theme } = useContext(ThemeContext);
	const blockTheme = theme?.['templates']?.[SinglePageThemeControls.slug]; // theme
	const tokensTheme = rawTheme?.tokens; // tokens
	const finalTheme = omit(blockTheme, ['variants']);
	// console.log('::: Final Theme ::: ', finalTheme);

	const rootClass = cx(
		'supt-singleArtist',
		getPageStyles(tokensTheme, finalTheme),
		getStyles()
	);

	const headerClass = cx(getHeaderStyles());

	const featuredImage = formatImage(node.featuredImage);

	return (
		<>
			<HeaderA
				title={node.title}
				introduction={node.artistCategories?.nodes
					.map((artist) => artist.name)
					.join(', ')}
				slug={blockHeaderA.slug}
				variant="default"
				className={headerClass}
			>
				<SectionTwoColumnsCol slug={`${blockHeaderA.slug}-left`} />
				<SectionTwoColumnsCol slug={`${blockHeaderA.slug}-right`}>
					{featuredImage && (
						<Image
							{...featuredImage}
							caption={featuredImage?.caption?.replace(
								/(<([^>]+)>)/gi,
								''
							)}
						/>
					)}
				</SectionTwoColumnsCol>
			</HeaderA>
			<Container className={rootClass} onClick={handleInternalLinks}>
				<Blocks blocks={blocks} excludes={/^supt\/header-a/g} />
			</Container>
		</>
	);
}
